import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit, Form } from 'redux-form/immutable';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
// import Toggle from 'material-ui/Toggle';
import _ from 'lodash';
import {
  SelectField,
  TextField,
  Toggle,
} from 'redux-form-material-ui';

import ReduxDialog from '../Common/ReduxDialog';
import commonStyles from '../styles';
import styles from './styles';
import { showDialog, hideDialog } from '../../actions/dialogs';
import { id } from '../../utils/helper';

const QUESTION_TYPES = [
  {
    code: 'YN',
    name: 'Yes/No',
    description: 'Request user to confirm a specified action',
  }, {
    code: 'PH',
    name: 'Upload Image',
    description: 'Request user to upload image as evidence',
  },
];

class QualityControlQuestionDialog extends Component {
  static propTypes = {
    // question: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,

    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  componentWillMount() {
  }

  renderType = (type) => {
    return (<div style={styles.type}>
      <div style={styles.typeName}>{type.name}</div>
      <div style={styles.typeDesc}>{type.description}</div>
    </div>);
  };

  render() {
    const { handleSubmit, submit } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.hideDialog('qualityControlQuestion')}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => submit('QualityControlQuestion')}
      />,
    ];

    return (
      <div>
        <ReduxDialog
          name="qualityControlQuestion"
          title={'Quality Control Question'}
          subTitle={'Add items to a check list which must be completed prior to task completion'}
          actions={actions}
          modal
          bodyStyle={styles.body}
        >
          <Form onSubmit={handleSubmit}>
            <div style={styles.container}>
              <div>
                <Field
                  name="question"
                  style={commonStyles.input}
                  component={TextField}
                  floatingLabelText="Question"
                  floatingLabelFixed
                  fullWidth
                />
              </div>
              <div>
                <Field
                  name="type"
                  style={commonStyles.input}
                  component={SelectField}
                  floatingLabelText="Type"
                  floatingLabelFixed
                  fullWidth>
                  { QUESTION_TYPES.map((type) => <MenuItem
                    key={type.code}
                    value={type.code}
                    style={styles.iconItem}
                    label={type.name}
                  >{this.renderType(type)}</MenuItem>) }
                </Field>
              </div>
              <div>
                <Field
                  name="mandatory"
                  label="Mandatory"
                  style={styles.toggle}
                  component={Toggle}
                />
                <div>Choose whether this question <b>must</b> be answered to complete the QA step</div>
              </div>
            </div>
          </Form>
        </ReduxDialog>
      </div>
    );
  }
}

const form = reduxForm({
  form: 'QualityControlQuestion',  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    console.log('QualityControlQuestion');
    const question = values.toJS();
    return props.onSave(_.assign({ id: id() }, question));
  },
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog('qualityControlQuestion');
  },
  // onSubmitSuccess: (result, dispatch, props) => {
  //   console.log('onSubmitSuccess');
  //   props.hideDialog('jobprofile');
  // },
  // onSubmitFail: (err) => {
  //   console.log('onSubmitFail', err);
  // },
  // validate,
  // asyncValidate
  // enableReinitialize: true,
})(QualityControlQuestionDialog);

function mapStateToProps(state) {
  const question = state.getIn(['dialogs', 'dialogs', 'qualityControlQuestion', 'context', 'question']);

  return {
    initialValues: question ? question.toJS() : null,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit,
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/QualityControlQuestionDialog/index.js